import React, { Component } from 'react'
import * as GrommetApp from 'grommet/components/App'
import Article from 'grommet/components/Article'
import CopperCoastParticles from './components/CopperCoastParticles'
import Header from './components/Header'
import Title from 'grommet/components/Title'
import SlideUpMenu from './components/SlideUpMenu'
import Footer from './components/Footer'
import Overlay from './components/Overlay'
import { Switch, withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import animateScrollTo from 'animated-scroll-to'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { setParticleVisibility, setSectionProperty } from './actions/sections/SectionsActions'
import { setWindowHeight, setMobile } from './actions/ConfigActions'
import Home from './components/Home'
import CmsArticle from './components/CmsArticle'
import Sitemap from './components/Sitemap'
import { Route } from 'react-router-dom'
import logo from './resources/images/white-logo.png'
import routes from './resources/routes'
import CookieConsent from "react-cookie-consent"
import './App.css'

@connect((state) => ({
  homeParticlesVisible: state.sectionsReducer.home.sectionOneParticlesVisible,
  appParticlesVisible: state.sectionsReducer.home.sectionTwoParticlesVisible,
  appLogoAnimating: state.sectionsReducer.header.appLogoAnimating,
  windowHeight: state.configReducer.windowHeight,
  isMobile: state.configReducer.mobile,
  sectionThreeSeparatorExpanded: state.sectionsReducer.services.sectionThreeSeparatorExpanded,
  overlayVisible: state.sectionsReducer.overlay.isVisible
}), { setParticleVisibility, setWindowHeight, setSectionProperty, setMobile })
class App extends Component {
  handleRouting = (props) => {
    if (props && props.location && props.location.hash) {
      var el = props.location.hash.replace('#', '')
      const targetElement = document.getElementById(el)
      if (targetElement) {
        const yCoordinates = (targetElement.offsetTop)
        animateScrollTo(yCoordinates, { speed: 800 })
      }
    }
  }
  animateHeaderLogo = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('header', 'appLogoAnimating', true)
    setTimeout(function () {
      setSectionProperty('header', 'appLogoAnimating', false)
    }, 2000)
  }

  handleAppLogoClick = () => {
    //this.animateHeaderLogo()
    this.handleRouting({location: { hash: '#agency'}})
  }

  handleWindowResize = () => {
    const { setWindowHeight } = this.props
    setWindowHeight(window.innerHeight)
    this.checkIfMobile()
  }

  checkIfMobile = () => {
    const { setMobile } = this.props
    const isMobile = window.innerWidth <= 544
    setMobile(isMobile)
  }

  UNSAFE_componentWillMount() {
    const{ setWindowHeight } = this.props
    setWindowHeight(window.innerHeight)
    this.checkIfMobile()
  }

  componentDidMount () {
    if (window.innerWidth > 544) window.addEventListener('resize', this.handleWindowResize, false)
  }

  componentWillUnmount () {
    if (window.innerWidth > 544) window.removeEventListener('resize', this.handleWindowResize, false)
  }

  render() {
    const { appParticlesVisible, windowHeight, appLogoAnimating, overlayVisible } = this.props
    const containerHeight = windowHeight ? `${windowHeight}px` : '100%'
    const appLogoClassName = `App-logo${appLogoAnimating ? ' is-animating' : '' }`
    return (
      <GrommetApp centered={false} className="App" id="App" style={{ height: containerHeight}}>
        <Article scrollStep={false} className="App-article" id="App-article">
          <Header>
            <div className="App-copperCoastHeaderLogo">
              <Link to="/#agency">
                <img alt="Copper Coast Technologies" className={appLogoClassName} src={logo}/>
              </Link>
            </div>
            <div className="App-copperCoastHeaderText">
              <Title className="App-copperCoastTitle">Copper Coast Technologies</Title>
            </div>
          </Header>

          <Switch>
            <Route exact path="/" render={(props) => (<Home {...this.props}/>)} />
            <Route exact path="/sitemap" render={(props) => (<Sitemap { ...this.props} />)} />
            {
              routes.map((route, i) => (<Route key={`CmsArticle-${i}`} exact path={`/${route.path}`} render={(props) => (<CmsArticle title={route.title} description={route.description} {...this.props}/>)} />))
            }
          </Switch>


          <SlideUpMenu />
          <CookieConsent style={{justifyContent: "center"}} contentStyle={{flex: "0 0 100%", margin: "10px 10px 0 10px", textAlign: "center"}} buttonStyle={{ backgroundColor: "#ffffff", marginBottom: "10px", fontSize: "13px" }}>This website uses cookies to enhance the user experience.</CookieConsent>
          <Footer/>
          <ReactCSSTransitionGroup
            transitionName="Overlay"
            transitionEnter={true}
            transitionEnterTimeout={600}
            transitionLeave={true}
            transitionLeaveTimeout={600}
          >
            { overlayVisible && <Overlay/> }
          </ReactCSSTransitionGroup>
          <div id="App-lowerParticles" style={{top: '72px', width: '100%', height: '100%', position: 'fixed', backgroundColor: '#222'}}>
            <ReactCSSTransitionGroup
              transitionName="CopperCoastParticles"
              transitionEnter={true}
              transitionEnterTimeout={2000}
              transitionLeave={true}
              transitionLeaveTimeout={2000}
            >
            {appParticlesVisible && <CopperCoastParticles showStars mouseMoveContainerId="App-article" particlesId="CopperCoastParticles-sectionTwo" starsId="CopperCoastStars-sectionTwo" colour="#cd994b"/> }
            </ReactCSSTransitionGroup>
          </div>
        </Article>

      </GrommetApp>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js